export enum EntranceShuffle {
    None = 0,
    Coupled = 1,
    Uncoupled = 2
}
